import { c as _c } from "react/compiler-runtime";
import { Heading } from 'ui';
import { formatSlashedDDMMYYYY } from 'utils/DateFormats';
import { Divider } from '~/components/Divider';
import styles from '../TicketingInstruction.module.css';
import type { InterrailProps } from './interrail.types';
const Interrail = t0 => {
  const $ = _c(18);
  const {
    content
  } = t0;
  const {
    date,
    dateTitle,
    passesTitle,
    passes
  } = content;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Divider variant="horizontal" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== passesTitle) {
    t2 = <Heading className={styles.subtitle}>{passesTitle}</Heading>;
    $[1] = passesTitle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== passes) {
    t3 = passes.length > 0 && passes.map(_temp);
    $[3] = passes;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <ul data-test-id="ticketing-instruction-interrail-passes">{t3}</ul>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider variant="horizontal" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== dateTitle) {
    t6 = <Heading className={styles.title}>{dateTitle}</Heading>;
    $[8] = dateTitle;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== date) {
    t7 = date ? formatSlashedDDMMYYYY(date) : <p>To be confirmed</p>;
    $[10] = date;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider variant="horizontal" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t6 || $[16] !== t7) {
    t9 = <>{t1}{t2}{t4}{t5}{t6}{t7}{t8}</>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export { Interrail };
function _temp(pass) {
  return <li key={pass.id}><span className={styles.ticketTitle}>{pass.passengerName}</span>: <span>{pass.passNumber}</span></li>;
}